import { z } from 'zod';
export const roleSchema = z.enum(['admin', 'member']);
/** Claims carried by every access token. */
export const jwtClaimsSchema = z.object({
    sub: z.string().uuid(),
    tenant_id: z.string().uuid(),
    role: roleSchema,
    typ: z.literal('access'),
});
//# sourceMappingURL=context.js.map